const initNewsLink = (link) => {
    link.addEventListener('click', (e) => {
        e.preventDefault();
        const fallbackLink = e.currentTarget.dataset.target;

        if (document.referrer.indexOf('/news') !== -1) {
            history.back();
        } else if (fallbackLink) {
            window.location.href = fallbackLink;
        }
    });
};

export default initNewsLink;